import { render, staticRenderFns } from "./CoaConfiguration.vue?vue&type=template&id=783361ee&"
import script from "./CoaConfiguration.vue?vue&type=script&lang=js&"
export * from "./CoaConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CoaConfiguration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports